module.exports = __webpack_public_path__ + "static/img/leerya.22a83d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/leerya.jpg
// module id = 5imd
// module chunks = 0